/* global axios */
import ApiClient from './ApiClient';

class ConversationMonitoringAPI extends ApiClient {
  constructor() {
    super('conversation_monitoring', { accountScoped: true });
  }

  overview(params = {}) {
    return axios.get(`${this.url}/overview`, { params });
  }

  responseWindows(params = {}) {
    return axios.get(`${this.url}/response_windows`, { params });
  }

  settings() {
    return axios.get(`${this.url}/settings`);
  }

  jobHealth() {
    return axios.get(`${this.url}/job_health`);
  }

  auditEvents() {
    return axios.get(`${this.url}/audit_events`);
  }

  updateSettings(responseSettings) {
    return axios.patch(`${this.url}/settings`, {
      response_settings: responseSettings,
    });
  }
}

export default new ConversationMonitoringAPI();
